"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedAbilities = void 0;
const enums_1 = require("../enums");
class SharedAbilities {
    constructor(user, profiles) {
        this.user = user;
        this.profiles = profiles;
    }
    hasSomeRole(role) {
        return this.profiles.some(({ user_organization, }) => (user_organization.role & role) === role);
    }
    hasEveryRole(role) {
        return this.profiles.every(({ user_organization, }) => (user_organization.role & role) === role);
    }
    canImplicit(organization_id, action, subject) {
        const profiles = organization_id ? this.profiles.filter(({ user_organization, }) => user_organization.superadmin_profile_id || (user_organization.organization_ids || []).includes(organization_id)) : this.profiles;
        if (!profiles.length)
            return false;
        return profiles.some(({ ability, user_organization, }) => ability.canImplicit(this.user, user_organization, action, subject));
    }
    can(organization_id, action, subject, item) {
        const profiles = organization_id ? this.profiles.filter(({ user_organization, }) => user_organization.superadmin_profile_id || (user_organization.organization_ids || []).includes(organization_id)) : this.profiles;
        if (!profiles.length)
            return false;
        if (subject === enums_1.PermissionEnum.User) {
            return item.__organizations.every(uo => {
                const profile = profiles.find(profile => { var _a; return (_a = profile.user_organization.organization_ids) === null || _a === void 0 ? void 0 : _a.includes(uo.organization_id); });
                return profile && profile.ability.can(this.user, profile.user_organization, action, subject, item);
            });
        }
        return profiles.some(({ ability, user_organization, }) => ability.can(this.user, user_organization, action, subject, item));
    }
    getAbilities() {
        return this.profiles;
    }
    getAgentAbilities() {
        return this.profiles.filter(profile => (profile.user_organization.role & enums_1.RoleEnum.Agent) === enums_1.RoleEnum.Agent);
    }
}
exports.SharedAbilities = SharedAbilities;
